import shoppingBags from '@/public/images/product-cards/1_bags.webp';
import hooray from '@/public/images/product-cards/2_hooray.webp';
import girl from '@/public/images/product-cards/3_girl.webp';

export const forBusiness_apparel_benefits = [
	{
		image: shoppingBags,
		columnTitle: 'benefitsData_column1_columnTitle',
		items: [
			{
				icon: '🔹',
				title: 'benefitsData_column1_title1',
				subtitle: 'benefitsData_column1_subtitle1',
			},
			{
				icon: '🔹',
				title: 'benefitsData_column1_title2',
				subtitle: 'benefitsData_column1_subtitle2',
			},
			{
				icon: '🔹',
				title: 'benefitsData_column1_title3',
				subtitle: 'benefitsData_column1_subtitle3',
			},
		],
	},
	{
		image: hooray,
		columnTitle: 'benefitsData_column2_columnTitle',
		items: [
			{
				icon: '🔹',
				title: 'benefitsData_column2_title1',
				subtitle: 'benefitsData_column2_subtitle1',
			},
			{
				icon: '🔹',
				title: 'benefitsData_column2_title2',
				subtitle: 'benefitsData_column2_subtitle2',
			},
			{
				icon: '🔹',
				title: 'benefitsData_column2_title3',
				subtitle: 'benefitsData_column2_subtitle3',
			},
		],
	},
	{
		image: girl,
		columnTitle: 'benefitsData_column3_columnTitle',
		items: [
			{
				icon: '🔹',
				title: 'benefitsData_column3_title1',
				subtitle: 'benefitsData_column3_subtitle1',
			},
			{
				icon: '🔹',
				title: 'benefitsData_column3_title2',
				subtitle: 'benefitsData_column3_subtitle2',
			},
			{
				icon: '🔹',
				title: 'benefitsData_column3_title3',
				subtitle: 'benefitsData_column3_subtitle3',
			},
		],
	},
];
